var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29695 6.06878L2.61293 0.384766L0.989258 2.00844L8.29695 9.31613L15.6046 2.00844L13.981 0.384766L8.29695 6.06878Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBackArrow);
export default __webpack_public_path__ + "static/media/selected-back-arrow.e4981ea58b1a8f90e9f09cd7c7ce5b50.svg";
export { ForwardRef as ReactComponent };